// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"0f1a47cd","382":"b77ae778","595":"7e696398","759":"d38f87d1","801":"d96e37e1","834":"490e1a91","840":"cba72d0d"}[chunkId] + ".chunk.js";
};